import{g as e}from"./generateUtilityClasses-4169ea48.js";import{g as t}from"./createTheme-c3f66f95.js";function i(e){return t("MuiDialogTitle",e)}var r=e("MuiDialogTitle",["root"]);export{r as d,i as g};
